import { CircleEllipsis, Droplets, Lightbulb, PawPrint, ShieldCheck, Trash2, Trees } from "lucide-react";

export const JENIS_OPTIONS = [
  { value: "Keamanan & Ketertiban", desc: "Tamu mencurigakan, kebisingan, portal, dll.", icon: ShieldCheck },
  { value: "Kebersihan & Sampah", desc: "Jadwal angkut sampah, tumpukan sampah, dll.", icon: Trash2 },
  { value: "Fasilitas Umum & Infrastruktur", desc: "Lampu jalan mati, jalan rusak, fasilitas umum, dll.", icon: Lightbulb },
  { value: "Drainase & Saluran Air", desc: "Selokan mampet, potensi genangan/banjir, dll.", icon: Droplets },
  { value: "Hewan Peliharaan & Liar", desc: "Hewan berkeliaran, kotoran hewan, dll.", icon: PawPrint },
  { value: "Penghijauan & Pohon Rindang", desc: "Pohon rimbun menghalangi jalan/kabel, dll.", icon: Trees },
];

const LEGACY_JENIS = { value: "Lain-lain", desc: "", icon: CircleEllipsis };

export const STATUS_OPTIONS = ["Menunggu", "Dalam Proses", "Selesai"];

export const STATUS_STYLES = {
  Menunggu: { badge: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  "Dalam Proses": { badge: "bg-blue-50 text-blue-800 border-blue-200", dot: "bg-blue-500" },
  Selesai: { badge: "bg-emerald-50 text-emerald-800 border-emerald-200", dot: "bg-emerald-500" },
};

export const DEFAULT_FILTERS = { jenis: "all", status: "all", q: "", from: "", to: "" };

export const MAX_FILES = 3;
export const MAX_FILE_SIZE = 25 * 1024 * 1024;
export const MEDIA_EXT = /\.(jpe?g|png|gif|webp|heic|heif|bmp|tiff?|avif|mp4|mov|m4v|avi|mkv|webm|3gp|3g2|wmv|flv|mpe?g|ts)$/i;

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const jenisMeta = (value) => JENIS_OPTIONS.find((j) => j.value === value) || LEGACY_JENIS;
